// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3g7i0","left":"styles_left__msQnE","right":"styles_right__YScJr","alert":"styles_alert__1HbQl"};